import { toast } from "react-toastify";

export const errorNotification = (value, position) => toast.error(`${value}!`, {
  closeOnClick: true,
  draggable: true,
  progress: undefined,
  position: position ? position : 'top-right'
});
export const successNotification = (value, position) => toast.success(`${value}!`, {
  closeOnClick: true,
  draggable: true,
  progress: undefined,
  position: position ? position : 'top-right'
});

export const warningNotification = (value,position) => toast.warn(`${value}!`, {
  closeOnClick: true,
  draggable: true,
  progress: undefined,
  position: position ? position : 'top-right'
});

export const infoNotification = (value, position) => toast.info(`${value}!`, {
  closeOnClick: true,
  draggable: true,
  progress: undefined,
  position: position ? position : 'top-right'
});